
interface CategoryCardProps {
  category: {
    id: string;
    name: string;
    icon: string;
    count: number;
  };
  onClick?: () => void;
}

export default function CategoryCard({ category, onClick }: CategoryCardProps) {
  return (
    <div 
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow cursor-pointer group"
      onClick={onClick}
    >
      <div className="text-center">
        <div className="w-16 h-16 bg-gradient-to-br from-[#1C1C1C] to-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
          <i className={`${category.icon} text-white text-2xl w-6 h-6 flex items-center justify-center`}></i>
        </div>
        <h3 className="text-lg font-semibold text-[#1C1C1C] mb-2 group-hover:text-[#D4AF37] transition-colors">
          {category.name}
        </h3>
        <p className="text-gray-600 text-sm">
          {category.count.toLocaleString()} عنصر
        </p>
      </div>
    </div>
  );
}
